<template>
  <v-dialog v-model="internalVisible" persistent max-width="400px">
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- Dialog: CONFIRMAR ACCION -->
    <v-dialog v-model="confirmDialog" max-width="350">
      <v-card class="py-3">
        <v-card-title class="headline"> ¿Desea continuar? </v-card-title>
        <v-card-text class="subtitle-1">
          Esta acción creará un nuevo turno con el equipo
          <span class="font-weight-medium">"{{ getEquipoName }}"</span>.
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="iniciarTurno"> Continuar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="pt-4 tb-3 text-center">
      <v-card-title class="headline pt-4 flex-column">
        <v-flex> Bienvenido/a!</v-flex>
        <v-flex class="subtitle-2"> {{ userInfo.nombre }} </v-flex>
      </v-card-title>
      <v-divider class="mx-6"></v-divider>
      <v-card-text class="pt-4 py-2">
        <v-stepper v-model="steps">
          <v-stepper-items>
            <v-stepper-content step="1" class="px-6 py-12 mt-4 mb-3">
              <v-flex class="subtitle-1 font-weight-medium mb-4 black--text">
                ¿Requerirá utilizar equipo adicional?
              </v-flex>
              <v-layout class="d-flex justify-space-between mb-2 px-8">
                <v-flex>
                  <v-btn outlined color="primary" block @click="iniciarTurno">
                    No
                  </v-btn>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-btn color="primary" block @click="steps = 2"> Si </v-btn>
                </v-flex>
              </v-layout>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-flex class="subtitle-2 black--text"
                >Por favor, selecciona un equipo:</v-flex
              >
              <v-autocomplete
                v-model="equipoDisponibleId"
                :loading="loadEquipos"
                :items="equiposDisponibles"
                @click="listarEquiposDisponibles"
                item-value="equipoId"
                item-text="nombre"
                label="Equipos"
                clearable
              >
              </v-autocomplete>
              <v-btn
                block
                color="primary"
                class="mb-2"
                @click="confirmDialog = true"
                :disabled="!equipoDisponibleId"
                >Seleccionar</v-btn
              >
              <v-btn block outlined color="primary" @click="atras">
                Atras
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions class="px-6 pb-4"> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import decode from "jwt-decode";

export default {
  name: "AsignarEquipoInspector",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    token: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      steps: 1,
      confirmDialog: false,
      equipoId: null,
      equipos: [],
      snackState: false,
      snackText: "",
      snackColor: "primary",
      snackTime: 3500,
      userInfo: {},
      loadEquipos: false,
      extensiones: [],
      equipoDisponibleId: null,
      equiposDisponibles: [],
      internalVisible: this.visible,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.listarEquipos();
        this.decodeToken();
        this.listarEquiposDisponibles();
      }
      this.internalVisible = val;
    },
  },
  computed: {
    getEquipoName() {
      if (this.equipoDisponibleId == null) return "";
      const equipo = this.equiposDisponibles.filter(
        (eq) => eq.equipoId == this.equipoDisponibleId
      );

      if (equipo.length == 0) return "";

      return `${equipo[0].nombre}`;
    },
  },
  created() {
    this.decodeToken();
    this.listarEquipos();
    this.listarEquiposDisponibles();
  },
  methods: {
    atras() {
      this.steps = 1;
      this.equipoDisponibleId = null;
    },
    listarEquipos() {
      let header = { Authorization: "Bearer " + this.$props.token };
      let configuracion = { headers: header };

      axios
        .get("api/Equipos", configuracion)
        .then((res) => (this.equipos = res.data))
        .catch((err) => console.error(err));
    },
    listarEquiposDisponibles() {
      this.equipoDisponibleId = null;
      this.loadEquipos = true;

      let header = { Authorization: "Bearer " + this.$props.token };
      let configuracion = { headers: header };

      axios
        .get("api/Equipos/Disponibles", configuracion)
        .then((res) => (this.equiposDisponibles = res.data))
        .catch((err) => console.error(err.data))
        .finally(() => (this.loadEquipos = false));
    },
    decodeToken() {
      if (this.token) {
        this.userInfo = decode(this.token);
      }
    },
    iniciarTurno() {
      this.decodeToken();

      let header = { Authorization: "Bearer " + this.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/HistorialInspectores",
          {
            equipoId: this.equipoDisponibleId,
            usuarioId: this.userInfo.idUsuario,
          },
          configuracion
        )
        .then((res) => {
          if (res.status == 200) {
            this.$store.dispatch("guardarToken", this.token);

            this.snackText = "¡Turno Iniciado!";
            this.snackColor = "primary";
            this.snackTime = 2000;
            this.snackState = true;

            this.$router.push({ name: "novedades" });
          }
        })
        .catch((err) => {
          this.snackText = "No se pudo crear el Turno.";
          this.snackColor = "red";
          this.snackTime = 6000;
          this.snackState = true;

          this.confirmDialog = false;
          this.listarEquiposDisponibles();

          console.error(err);
        });
    },
  },
};
</script>
